/**
 * API yorumları bazen `replies` ile iç içe döner; UI düz dizi + `parentCommentId` bekler.
 */
export function flattenCommentsWithNestedReplies(
  comments: any[] | undefined | null,
): any[] {
  if (!Array.isArray(comments) || comments.length === 0) return [];

  const out: any[] = [];

  const walk = (nodes: any[], fallbackParentId: number | null | undefined) => {
    for (const node of nodes) {
      if (!node || typeof node !== 'object') continue;
      const nested = node.replies;
      const { replies: _drop, ...rest } = node;
      const row: any = { ...rest };
      if (
        (row.parentCommentId === undefined || row.parentCommentId === null) &&
        fallbackParentId != null
      ) {
        row.parentCommentId = fallbackParentId;
      }
      out.push(row);
      if (Array.isArray(nested) && nested.length > 0) {
        walk(nested, row.id);
      }
    }
  };

  walk(comments, undefined);
  return out;
}
